import React from 'react';
import './Gallery.css';

function Gallery() {
  return (
    <div className="gallery-page">
  {/* //     <section className="gallery-hero">
  //       <h1>Services & Pricing</h1>
  //     </section>

  //     <section className="gallery-intro">
  //       <h2>Our Detailing Packages</h2>
  //       <p>Choose from our range of detailing services to keep your vehicle looking brand new.</p>
  //     </section>

  //     <section className="pricing-table">
  //       <div className="pricing-card">
  //         <h3>Basic Wash</h3>
  //         <p className="price">$50</p>
  //         <ul>
  //           <li>Hand Wash & Dry</li>
  //           <li>Interior Vacuum</li>
  //           <li>Windows & Mirrors Cleaned</li>
  //           <li>Wheel & Tire Shine</li>
  //         </ul>
  //       </div>

  //       <div className="pricing-card">
  //         <h3>Full Detail</h3>
  //         <p className="price">$150</p>
  //         <ul>
  //           <li>Everything in Basic Wash</li>
  //           <li>Wax & Paint Sealant</li>
  //           <li>Deep Interior Cleaning</li>
  //           <li>Leather & Fabric Conditioning</li>
  //         </ul>
  //       </div>

  //       <div className="pricing-card">
  //         <h3>Premium Ceramic Coating</h3>
  //         <p className="price">$500+</p>
  //         <ul>
  //           <li>Everything in Full Detail</li>
  //           <li>Multi-Layer Ceramic Protection</li>
  //           <li>6-12 Month Durability</li>
  //           <li>Water & Dirt Repellent Finish</li>
  //         </ul>
  //       </div>
  //     </section>

  //     <section className="cta-section">
  //       <p>Not sure which package is right for you? Contact us for a personalized recommendation!</p>
  //       <a href="/contact" className="cta-button">Get a Quote</a>
  //     </section> */}
    </div>
  );
}

export default Gallery;
